
  import { Options, Vue } from 'vue-class-component';
  import HelloWorld from '../../components/HelloWorld.vue';
  import {DataUtil} from '@/util/DataUtil';
  import {agreementConfig} from '@/config/template';

  @Options({
    components: {
      HelloWorld,
    }
  })
  export default class App extends Vue {
      private temp: string = agreementConfig.template_0111_ios;

      private config: TemplateInterface = {
          productName: '经典消消消',
          companyFullName: '海南逸鑫网络技术有限公司',
          companyShortName: '海南逸鑫',
          officialWebsite: 'https://www.hainanyixing.com/',
      };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
  }
